module.exports = __webpack_public_path__ + "img/c01_unittechballistatriremechampion_Normal_ua.72af7807.webp";